module.exports = __webpack_public_path__ + "static/media/vision_nocolor.529c2bf5.svg";